import * as actions from "../actions/constants";
import { initialState } from "./state";

const initialAction = {
  type: "",
  payload: "" || [] || 1 || true || {}, // get types
};

export const agendaReducer = (state = initialState, action = initialAction) => {
  switch (action.type) {
    case actions.GET_AVAILABLE_SCHEDULES:
      return {
        ...state,
        availableSchedules: action.payload,
      };

    case actions.CREATE_BOOKING:
      return {
        ...state,
        createdBooking: action.payload,
      };

    case actions.SELECT_SCHEDULE:
      return {
        ...state,
        selectedSchedule: action.payload,
      };

    case actions.SELECT_DATE:
      return {
        ...state,
        loader: true
      };

    case actions.SELECT_DATE_SUCCESS:
      return {
        ...state,
        availableSchedules: action.payload,
        loader: false
      };

    case actions.SELECT_DATE_ERROR:
      return {
        ...state,
        availableSchedules: action.payload,
        loader: false,
      };

    case actions.GET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
      };

    case actions.GET_BRANCH_NAME:
      return {
        ...state,
        branchName: action.payload.branchName,
        startCalendarDate: action.payload.startDate,
        endCalendarDate: action.payload.endDate,
        serviceName: action.payload.NameService,
        branchDate: action.payload.branchDate
      };

    case actions.SET_APPOINTMENT:
      return {
        ...state,
        createdBooking: action.payload.codeBook,
        paymentUrl: action.payload.paymentUrl,
        locationUrl: action.payload.locationUrl
      };

    case actions.SET_SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.payload,
        selectedSchedule: "",
      };

    case actions.SET_ERROR_APPOINTMENT:
      return {
        ...state,
        appointmentError: action.payload.appointmentError,
        appointmentErrorMessage: action.payload.appointmentErrorMessage
      };
      
    default:
      return { ...state };
  }
};
